import { FunctionComponent } from 'react';
import IntroMainContentDefault from './variants/IntroMainContentDefault';
import IntroMainContentNewPlayer from './variants/IntroMainContentNewPlayer';
import IntroMainContentExistingPlayer from './variants/IntroMainContentExistingPlayer';
import { IntroMainContentVariants } from './IntroMainContent.types';

export const INTRO_MAIN_CONTENT_COMPONENTS: Record<
  IntroMainContentVariants,
  FunctionComponent<object>
> = {
  default: IntroMainContentDefault,
  newPlayer: IntroMainContentNewPlayer,
  existingPlayer: IntroMainContentExistingPlayer,
};
